const LightTheme = {
  id: 'light',

  // ─── Legacy tokens (kept for backward compatibility) ─────────────────────
  primaryColor: 'black',
  secondaryColor: '#F19D9A',
  primaryColorDark: '#D98179',
  backgroundColor: '#FBF6F6',
  darkGrey: '#262223',
  mainFontParagraph: 'Poppins',
  mainFontHeading: 'Poppins',

  // ─── Breakpoints ──────────────────────────────────────────────────────────
  boxLayoutQuery: '(min-width: 600px)',
  desktopUp: '(min-width:1100px)',
  desktop: '(min-width:1100px) and (max-width: 1367px)',
  tabletOnly: '(min-width: 980px) and (max-width:1100px)',
  tabletBelow: '(max-width: 980px)',
  tabletUp: '(min-width: 768px)',
  phoneLand: '(max-width: 767px)',
  phonePort: '(max-width: 479px)',



  maxContentWidth: 1200,

  // ─── Colors ───────────────────────────────────────────────────────────────
  colors: {
    black:     '#0D0D0D',
    grey:      '#B9B2B5',
    lightGrey: '#E6E6E8',
    offWhite:  '#FAF7F8',
    white:     '#FFFFFF',
    darkRed:   '#590000',
    red:       '#F73E57',
  },

  // ─── Typography ───────────────────────────────────────────────────────────
  typography: {
    fontFamily: "'Poppins', Arial, Helvetica, sans-serif",

    fontSize: {
      xs:   '14px',
      sm:   '16px',
      md:   '18px',
      lg:   '22px',
      xl:   '24px',
      xxl:  '28px',
      xxxl: '32px',
      hero: '44px',
    },

    fontWeight: {
      normal:   400,
      semibold: 600,
      medium: 500,
    },

    lineHeight: {
      tight:  '18px',
      normal: '22px',
      md:     '33px',
      lg:     '35px',
      xl:     '42px',
      hero:   '48px',
    },

    letterSpacing: {
      none:    '0px',
      xs:      '0.04px',
      sm:      '0.05px',
      md:      '0.06px',
      negSm:  '-1.02px',
      negMd:  '-1.41px',
    },
  },
};

export default LightTheme;